module.exports = __webpack_public_path__ + "img/collection-engagementRings100Carat.a5c7972.webp";